/* global locale language */
/**
 * BatchGeoMap
 */
(function (window) {
  /**
   * Shrinks legWrap element if active filters are the only thing in legWrap/legDiv.
   */
  var handleLegWrapShrink = function (legWrapEl) {
    const hasFilterListWrap = legWrapEl.find(".filterListWrap");
    const hasColumnWrap = legWrapEl.find(".columnWrap");
    if (hasFilterListWrap.length && !hasColumnWrap.length) {
      legWrapEl.addClass("shrinkLegWrap");
    } else {
      legWrapEl.removeClass("shrinkLegWrap");
    }
  };

  var bgSize = function (now, hideLegend) {
    hideLegend = hideLegend || false;
    if (!now) {
      // we do this so it doesn't fire so many times in a row
      if (!window.resizeTimer) {
        window.resizeTimer = setTimeout(function () {
          bgSize(true, hideLegend);
          window.resizeTimer = null;
        }, 600);
      }
      return false;
    }

    var tableSizingPersist = new BatchGeoPersistence({ key: "TableSizing" });
    if (!BatchGeoStore.getState().App.isMap) return; // don't run on non-map screens
    BatchGeo.timer("bgSize() now: " + !!now);

    var map = window.batchGeoGoogleMapsManager.getMap();
    var preCenter = map.getCenter();
    // Cache relevant elements
    var $addressBox = $("#addressBox"),
      $legWrap = $("#legWrap"),
      $mapDiv = $("#mapDiv"),
      $topBar = $("#topBar"),
      $bgToolbar = window.batchGeoBaseToolbar.toolbarElement;

    // cache map width so we don't have to keep calling outerWidth();
    var mapWidth = $mapDiv.outerWidth();
    // $(window).height() doesn't work well on ios, jquery bug http://bugs.jquery.com/ticket/6724
    var windowHeight = window.innerHeight
      ? window.innerHeight
      : $(window).height();
    var windowWidth = window.innerWidth ? window.innerWidth : $(window).width();

    // Responsive variable to check against in order to hide/disable functions
    var mobileWidth = 319;

    // This is important! Iframes on iOS will try to resize to fit the content
    // in the iframe. So if you have an iframe that is set to 100px but the
    // content inside is not fluid *and* 200px it will resize iframe from 100px
    // to 200px. To prevent this we set a hard width and height to the initial
    // width and height. This will prevent it from resizing the iframe.
    if (BatchGeoDevices.is("ios") && BatchGeo.iframeDetect()) {
      $(document.body).css({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    // if no description center legend text
    if (!$("#description")[0]) $legWrap.css({ "text-align": "center" });

    // if mobile or printMode hide/show map refresh button
    $("#mapRefresh").toggle(
      !(BatchGeoDevices.is("mobile") || window.printMode),
    );
    // If windowHeight < 200 OR there's nothing in legWrap, hide it. Also check that
    // hideLegend is NOT falsy.
    $legWrap.toggle(
      windowHeight > 200 &&
        windowWidth > mobileWidth &&
        $legWrap.text().trim().length > 0 &&
        !hideLegend,
    );
    handleLegWrapShrink($legWrap);

    // if search exists on smaller widths modify the search placeholder
    if (mapWidth <= 768 && $("#searchForm")[0]) {
      if (mapWidth > 300 && locale === "us") {
        $addressBox.prop(
          "placeholder",
          "Search " +
            (document.getElementById("map-title")?.textContent ||
              document.title),
        );
        $("#bgLogo").hide();
      } else {
        $addressBox.prop("placeholder", "Search");
      }
    }

    var mapWrapHeight,
      state = BatchGeoStore.getState(),
      tableMapVisibility = state.BatchGeoTableMap.visibility,
      shouldRenderTable =
        state.App.shouldRenderTable ||
        state.BatchGeoTableMap.shouldForceRenderTable,
      isStoreLocatorMode = state.App.mapMode === "store_locator";

    // if there is cached sizes from the batchgeo Table Resizer then use those
    // heights, but because BatchGeoTable might not be loaded by the time the
    // table div is rendered dig into BatchGeoPersist for the sizes
    var cachedMapWrapSize = tableSizingPersist.fetch("mapWrap");

    if (shouldRenderTable && tableMapVisibility && windowWidth >= 300) {
      if (
        !BatchGeo.iframeDetect() &&
        cachedMapWrapSize &&
        windowHeight > cachedMapWrapSize
      ) {
        mapWrapHeight = cachedMapWrapSize;
      }
      // otherwise calculate new heights
      else {
        // mapWrapHeight set to 70% of the screen height as long as it's greater than 500px
        mapWrapHeight =
          windowHeight * 0.7 > 400 ? windowHeight * 0.7 : windowHeight - 5;
      }

      // Prevent the body scrollbar
      $(document.body).css("overflow", "hidden");
      $(".map-page-container").addClass("data-view-open");

      if (BatchGeo.isInIframe()) {
        $(".map-page-container").removeClass("iframe-scrollable");
      }
    } else {
      // If no table so mapWrapHeight gets the whole window otherwise use
      // the cached value
      mapWrapHeight =
        !BatchGeo.iframeDetect() &&
        cachedMapWrapSize &&
        !isStoreLocatorMode &&
        $("#data").length
          ? cachedMapWrapSize
          : windowHeight;

      var isMobile = BatchGeoDevices.is("mobile");
      var isDataViewMode = BatchGeoStore.getState().App.mapMode === "data_view";
      var dataVisible = $("#data").is(":visible");

      //if not mobile, on data_view mode and data is visible, show partial of the data list
      if (!isMobile && isDataViewMode && dataVisible) {
        mapWrapHeight = mapWrapHeight - 65;
      }

      // Hide scrollbar if exporting (detected png/pdf request)
      // Otherwise, don't block scrolling for old data view
      let scrollVal = BatchGeoStore.getState().App.isExporting
        ? "hidden"
        : "scroll";
      $(document.body).css("overflow", scrollVal);
      $(".map-page-container").removeClass("data-view-open");

      if (BatchGeo.isInIframe()) {
        $(".map-page-container").addClass("iframe-scrollable");
      }
    }

    var legWrapHeight =
      $legWrap.text().trim().length && $legWrap.is(":visible")
        ? $legWrap.outerHeight()
        : 0;
    var topBarHeight = $topBar.is(":visible") ? $topBar.outerHeight() : 0;

    // set proper heights
    $("#mapWrap").css({
      height: mapWrapHeight,
      top: 0,
    });
    // mapDiv height equal to the wrap height minus contained elements (topBar + legWrap)
    $mapDiv.css("height", mapWrapHeight - (topBarHeight + legWrapHeight));
    $mapDiv.css("top", topBarHeight);
    $bgToolbar.css("top", topBarHeight + 9);

    // trigger relevent events for the rest of the app
    $.colorbox.resize({
      width: windowWidth <= 450 ? "100%" : 450,
    });

    google.maps.event.trigger(map, "resize");

    $(window).trigger("batchgeo.bgsize");

    if (preCenter) map.setCenter(preCenter);
    window.reorderGroups(false, 1);
  };

  var initializeLibraries = function () {
    // Save the state of the loaded scripts so we don't reload them
    BatchGeo.advancedModeInitialized = true;

    var drawingTools = {
      hand: BatchGeoDrawingManagerHand,
    };

    if (!BatchGeoDevices.is("mobile")) {
      drawingTools = Object.assign(drawingTools, {
        rectangle: BatchGeoDrawingManagerRectangle,
        circle: BatchGeoDrawingManagerCircle,
        ruler: BatchGeoDrawingManagerRuler,
        polygon: BatchGeoDrawingManagerPolygon,
      });
    }

    window.batchGeoDrawingManager = new BatchGeoDrawingManager({
      map: window.batchGeoGoogleMapsManager.getMap(),
      tools: drawingTools,
    });

    window.initBatchGeoShortcuts();

    BatchGeoStore.dispatch({ type: "LIBRARIES_LOADED" });
  };

  var setMapUnits = function () {
    setTimeout(function () {
      var units = window.batchGeoGoogleMapsManager.getDistanceScale();
      BatchGeoStore.dispatch({ type: "SET_MAP_UNITS", units: units });
    }, 100);
  };

  /**
   * Turns on advanced mode by loading the the required scripts for advanced mode.
   * If it's in dev mode it loads all the scripts individually or in prod it will
   * load the single compiled file. It turns on the custom context menu and
   * BatchGeoTable. It will only load the scripts once. Future calls will just
   * reinit the libraries.
   *
   * @return {undefined}
   */
  var initializeAdvancedMode = function () {
    var appState = BatchGeoStore.getState().App;
    var advancedModePersist = new BatchGeoPersistence({ key: "AdvancedMode" });

    if (!advancedModePersist.fetch("modeMessage") && !appState.isExporting) {
      advancedModePersist.set({ modeMessage: true });
    }

    initializeLibraries();
  };

  var disableAdvancedMode = function () {
    window.batchGeoDrawingManager.destroy();
    window.batchgeoKeyboardShortcuts.disable();

    bgSize();
  };

  var initMapLoadedListener = function () {
    /**
     * Everything in here happens once the map on the page is loaded. By this time
     * you will have access
     */
    BatchGeoStore.addListener("App", "mapLoaded", function (newState) {
      if (newState.mapLoaded) {
        $("#topButtons").append(
          BatchGeoUi.MobileDataViewButton({
            dataButtonStitcher: function () {
              return $("#topBar").find(".toolbar-icon-table");
            },
            mapButtonStitcher: function () {
              return $("#topBar").find(".toolbar-icon-map");
            },
          }),
        );

        $("#mapDiv").on("click", ".gm-style-cc", setMapUnits);

        $("#map-title").on("click", window.batchGeoMap.mapReset);

        $("#addressBox").on("focus", function () {
          $(".toggle-mobile-data-view").addClass("hide");
        });
        $("#addressBox").on("blur", function () {
          $(".toggle-mobile-data-view").removeClass("hide");
        });

        // Manages UI changes when the shouldRenderTable option is toggled
        BatchGeoStore.addListener(
          "App",
          "shouldRenderTable",
          function (nextState) {
            var $page = $("#page");
            // If the table is NOT on we want to display the #page element and vice versa
            $page.toggle(!nextState.shouldRenderTable);

            // Set active class based on app state
            var $tableIcon = $("#topBar").find(
              ".toggle-mobile-data-view > .toolbar-icon-table",
            );
            var $mapIcon = $("#topBar").find(
              ".toggle-mobile-data-view > .toolbar-icon-map",
            );
            if (nextState.shouldRenderTable) {
              BatchGeoStore.dispatch({
                type: "TABLE_MAP_SELECTABLE",
                isTableSelectable: true,
              });
              $tableIcon.addClass("active");
              $mapIcon.removeClass("active");
            } else {
              BatchGeoStore.dispatch({
                type: "TABLE_MAP_SELECTABLE",
                isTableSelectable: false,
              });
              $mapIcon.addClass("active");
              $tableIcon.removeClass("active");
            }
            // If the table is NOT on and if #data doesn't have it's content redraw it
            if (
              !nextState.shouldRenderTable &&
              !$.trim($page.find("#data").html())
            ) {
              window.batchGeoGoogleMapsMarker.MarkerDrawer.drawNonAdvancedTableMarkers();
            }
          },
        );

        // Everything below is to setup BatchGeo Pro™
        if (!newState.pro) return;

        var $advancedToggle = $(".advancedToggle");

        // If advanced mode is enabled on page load show the loader, hide list data
        // view and then init the advanced mode scripts
        if (newState.advanced) {
          $advancedToggle.addClass("on");
          initializeAdvancedMode();
        }

        // add advanced toggle handling
        $advancedToggle.on("click", function () {
          BatchGeoStore.dispatch({
            type: "FEATURE_TOGGLE",
            feature: "advanced",
          });
        });

        BatchGeoStore.addListener("App", "advanced", function (newState) {
          newState.advanced ? initializeAdvancedMode() : disableAdvancedMode();
          $advancedToggle.toggleClass("on", newState.advanced);
        });
      }
    });
  };

  var initStoreListeners = function () {
    // If you turn on the clusters we dont want heatmap ever
    BatchGeoStore.addListener("Cluster", "enabled", function (state) {
      if (state.enabled) {
        this.dispatch({ type: "HEATMAP_DISABLE" });
      }
    });

    // If you turn on heatmap clusters need to be hidden
    BatchGeoStore.addListener("HeatMap", "enabled", function (state) {
      if (state.enabled) {
        this.dispatch({ type: "CLUSTER_DISABLE" });
      }
    });

    // When filters are changed, and heatmap is enabled, we need to reload
    // the heatmap so it takes the filters into account
    BatchGeoStore.addListener("MarkerLegend", "filters", function () {
      if (BatchGeoStore.getState().HeatMap.enabled) {
        BatchGeoStore.dispatch([
          { type: "HEATMAP_DISABLE" },
          { type: "HEATMAP_ENABLE" },
        ]);
      }
    });

    // A listener for when libraries are all loaded and checks if there is
    // a shape param in the URL which indicates that we should load the
    // shape on page load.
    // NOTE: per #1256 this is (currently) only for circles.
    BatchGeoStore.addListener("App", "librariesLoaded", function (newState) {
      // window.librariesLoaded = true;
      // TODO: try isExporting here
      if (newState.librariesLoaded) {
        var startLat = BatchGeo.getQueryVariable("shapeStartLat");
        var startLng = BatchGeo.getQueryVariable("shapeStartLng");
        var endLat = BatchGeo.getQueryVariable("shapeEndLat");
        var endLng = BatchGeo.getQueryVariable("shapeEndLng");

        // Since BatchGeoDrawingManagerCircle has everything we need and
        // we want to mimic what it looked like to the user after they
        // had used they mouse to draw it we call it like this which is
        // a little funky looking but we're essentially injecting the
        // state the component was in at the time the user drew it.
        BatchGeoDrawingManagerCircle.buildShape
          .call({
            drawingManager: window.batchGeoDrawingManager,
            startPosition: new google.maps.LatLng(startLat, startLng),
            options: {},
          })
          .setOptions({
            radius: window.batchGeoDrawingManager.distanceBetweenTwoLatLng(
              new google.maps.LatLng(startLat, startLng),
              new google.maps.LatLng(endLat, endLng),
              "m",
            ),
          });
      }
    });
  };

  var initializeModules = function (callback) {
    callback = callback || function () {};
    var initializeLibraries = function () {
      // Return and execute callback if modules are already ready
      if (BatchGeo.modulesInitialized) {
        callback();
        return;
      }

      BatchGeo.timer("start initializeModules()");

      var featureFlipPersist = new BatchGeoPersistence({
        key: "FeatureFlipPersist",
      });
      var dataTableVisibilityPersist = new BatchGeoPersistence({
        key: "DataTableVisibilityPersist",
      });
      var appState = BatchGeoStore.getState().App;
      BatchGeo.modulesInitialized = true;

      BatchGeoStore.addListener(
        "App",
        "lastToggledFeature",
        function (newState) {
          var feature = newState.lastToggledFeature;
          var featureValue = !!newState[feature];

          window.BatchGeoTrack.event({
            featureName: feature,
            eventName: "toggle",
            eventValue: featureValue,
          });

          if (feature == "shouldRenderTable") {
            dataTableVisibilityPersist.set(
              BatchGeoStore.getState().App.mapId,
              featureValue,
            );
          } else {
            featureFlipPersist.set(feature, featureValue);
          }
        },
      );

      //initializing the google manager module does not return a Google Map.
      window.batchGeoGoogleMapsManager = new BatchGeoGoogleMapsManager({
        markersData: window.per,
      });

      window.batchGeoBaseToolbar = new BatchGeoBaseToolbar();
      new BatchGeoOptimalRouteToolbar();

      // Cache the width and only run bgSize if the width actually changes. On
      // iOS it sometimes calls onresize seemingly randomly or way too much.
      // This will prevent that.
      var windowWidth = $(window).width();
      var windowHeight = $(window).height();
      window.onresize = function () {
        window.reorderGroups(false);
        if (windowWidth !== $(window).width()) {
          windowWidth = $(window).width();
          bgSize();
        }
        if (windowHeight !== $(window).height()) {
          windowHeight = $(window).height();
          bgSize();
        }
      };

      // Listen for orientation changes on mobile so we can resize the map
      window.onorientationchange = function () {
        window.reorderGroups(false);
        bgSize();
      };

      // Initialize the streetview listener to show/hide
      var thePanorama = window.batchGeoGoogleMapsManager
        .getMap()
        .getStreetView();
      google.maps.event.addListener(
        thePanorama,
        "visible_changed",
        function () {
          thePanorama.getVisible()
            ? window.batchGeoBaseToolbar.hide()
            : window.batchGeoBaseToolbar.show(); // jshint ignore:line
        },
      );

      window.batchGeoGoogleMapsMarker = new BatchGeoGoogleMapsMarker({
        markersData: window.per,
      });

      // need the clarker overlay module before userlocation can init
      window.initClarkerOverlayModule();

      window.batchGeoUserLocation = new BatchGeoUserLocation();
      window.batchGeoPrinter = new BatchGeoPrinter();

      new window.BatchGeoDataAndTableResizer({
        container: "#data",
      });

      if (BatchGeo.iframeDetect()) {
        $("#topBar").find(".toggle-icon-wrapper").hide();
      }

      if (!window.per.isMapPreview) {
        window.batchGeoMapContextMenu = window.BatchGeoMapContextMenu();
        window.batchGeoMapContextMenu.init();
      }

      // if (!window.per.isMapPreview) {
      //   $("#mapDiv").append(
      //     $("<button />", {
      //       class: "batchgeo-map-owner-trigger-button",
      //       text: "Contact map owner",
      //       type: "button",
      //       click: function () {
      //         BatchGeoContactOwner.render();
      //       },
      //     }),
      //   );
      // }

      if (!appState.isMap) {
        // We need to hydrate the true initial state of custom extents
        // if a custom extent exists in the payload
        if (window.per.custom_extent) {
          BatchGeoStore.dispatch({
            type: "SET_EXTENT",
            bounds: window.per.custom_extent,
          });
        }

        $("#mapDiv").append(
          $("<div />", {
            addClass: "batchgeo-custom-buttons",
          }),
        );

        // After hydrating initialize the component
        new window.BatchGeoCustomExtents({
          container: ".batchgeo-custom-buttons",
          map: window.batchGeoGoogleMapsManager.getMap(),
          defaultMode:
            appState.isEdit && window.per.custom_extent
              ? BatchGeoCustomExtents.modes.RESET
              : null,
        });
      }

      callback();
      BatchGeo.timer("end initializeModules()");
    };

    initializeLibraries();
  };

  /**
   * Has the logic on showing or hiding the Data View as well as sets up the listeners.
   */
  var initializeTable = async function () {
    var appState = BatchGeoStore.getState().App;

    // For pages like the edit and home we never want to enable any part of this
    if (appState.isMap) {
      // Flips the visibility of the dataView when TABLE_MAP_VISIBILITY is flipped
      BatchGeoStore.addListener(
        "BatchGeoTableMap",
        "visibility",
        function (newState) {
          var isVisible = newState.visibility;
          $("#dataView").toggle(isVisible);
        },
      );

      var tableVisibility = appState.shouldRenderTable;

      // If hide address is true and that's the only column we default the
      // dataView off since most of the time it's not useful
      if (window.per.hideaddr_cb && window.per.columnNames.length === 1) {
        tableVisibility = false;
      }

      // Force map to render first when starting up on mobile sizes
      if (BatchGeoDevices.is("phone")) {
        tableVisibility = false;
      }

      // Finally, display it if tableVisibility is truthy.
      // NOTE: this should always come after BatchGeoTableMap otherwise some display
      // logic can get messed up. See: 3d2a052
      BatchGeoStore.dispatch({
        type: "TABLE_MAP_VISIBILITY",
        visibility: tableVisibility,
      });

      // Boot up the actual table
      window.batchGeoTableMap = new window.BatchGeoTableMap({
        map: window.batchGeoGoogleMapsManager.getMap(),
        markers: window.batchGeoGoogleMapsMarker.getMarkersObjArray(),
        data: window.per,
      });

      new BatchGeoMarkerMeasure();
    } else {
      // Bypass the table row-select since there is no table on create/edit pages
      BatchGeoStore.addListener(
        function (state) {
          return state.MapsMarkersManager.clickedMarker;
        },
        function (nextMarker, prevMarker) {
          return nextMarker != prevMarker;
        },
        function (nextMarker, prevMarker) {
          window.batchGeoGoogleMapsMarker.MarkerResizer.zoomOut(prevMarker);
        },
      );
    }
  };

  /**
   * Has the logic to know to enable or not to enable the heatmap component on
   * load depending on the user and map. The logic is like this:
   *
   * 1. If the map has a falsy default heatmap option (heatmap_default) then it
   *    will check if the feature is enabled.
   *
   * 2. If heatmap_default is true it checks if the feature has ever been toggled
   *    by the user
   *
   *    2a. If the feature has been toggled by the user we use that to determine
   *        to show or hide the heatmap
   *
   *    2b. If the feature has NOT been toggled ever we enable heatmap
   */
  var initializeHeatmapComponent = async function () {
    var state = BatchGeoStore.getState();
    window.batchGeoHeatMap = new BatchGeoHeatMap();

    // Setup a listener for when the heatmap is turned on or off. We want to only set
    // this listener up once though!
    if (!state.HeatMap.initialized) {
      BatchGeoStore.dispatch({ type: "HEATMAP_INITIALIZE" });
      BatchGeoStore.addListener("HeatMap", "enabled", function (nextState) {
        var method = nextState.enabled ? "enable" : "disable";
        window.batchGeoHeatMap[method]();

        // If it's NOT edit then we want to track the user's heatmap preference
        if (!state.App.isEdit) {
          // TODO(tom) disabling this temporarily, but it's worth looking into
          // how we have this listener set and potential run when heatMapPersist
          // is not yet defined.
          // eslint-disable-next-line no-use-before-define
          heatMapPersist.set(appState.mapId, nextState.enabled);
        }
      });
    }

    // If we're on the edit page and heatmap is set as the default option we need to
    // manually turn on drawing again, draw markers, then enable the heatmap. We can't
    // look at localStorage or listen for heatmap context menu toggle events because
    // we need to give a preview of what the map *would* look like.
    if (state.App.isEdit) {
      BatchGeoStore.dispatch({ type: "MARKER_DRAWER_ENABLE_DRAWING" });
      // window.batchGeoGoogleMapsMarker.MarkerDrawer.draw(); - pkh - not sure why this is needed?
      var method = window.per.heatmap_default ? "enable" : "disable";
      if (method == "enable") window.batchGeoHeatMap[method](); // pkh - trying to avoid running if disabled, calls drawMarkers (expensive routine)
    }
    // If it's NOT edit and not defaulted to heatmaps we can go ahead and figure out
    // if we should be rendering the heatmap or not based on map settings, user prefs
    // or current state.
    else {
      var appState = state.App;
      var heatMapPersist = new BatchGeoPersistence({ key: "HeatMap" });

      // Default to null which is different than false. Null in this case means it
      // hasn't ever been set yet. False is off, true is on.
      var featureEnabled = null;

      // If the current page has a `mapId` then it's probably a map page and if it
      // it's a map page that means a user could have set heatmap on so remember
      // their selection.
      if (
        appState.mapId &&
        !BatchGeo.iframeDetect() &&
        heatMapPersist.fetch(appState.mapId) !== undefined
      ) {
        featureEnabled = heatMapPersist.fetch(appState.mapId);
      }
      // If the user hasn't specifically set an option check if there's a default set
      else if (window.per.heatmap_default) {
        featureEnabled = true;
      }
      // If heatmap is already set in the state, use that. This allows you to override
      // localStorage by using HYDRATE_INITIAL_STATE
      else if (appState.heatmap) {
        featureEnabled = !!appState.heatmap;
      }

      // Do an initial on/off dispatch for heatmap. It may be on from
      if (featureEnabled) {
        // pkh - only do this if heatmap needs to be on
        BatchGeoStore.dispatch({
          type: "HEATMAP_SET_ENABLED",
          enabled: featureEnabled,
        });
      }
    }
  };

  function BatchGeoMap(opts) {
    var options = $.extend(
      {
        edit: false,
      },
      opts,
    );

    // If we're in an iframe, as soon as we can, add a class to tell CSS that we're
    // in an iframe so we can hide/show different UIs
    $(document.body).toggleClass("in-iframe", BatchGeo.iframeDetect());

    if (options.edit) {
      // are we on edit page?
      BatchGeoStore.dispatch({
        type: "EDIT_PAGE",
        isEdit: true,
      });
    }

    window.BatchGeoMapScaleBarDefaultUnit();

    initMapLoadedListener();
    initStoreListeners();
  }

  var doMap = async function () {
    // initializes map for the first time, should only be ran once
    if (!BatchGeo.modulesInitialized) {
      //We still don't have modules ready, initialize and come back
      return initializeModules(doMap);
    }

    await Promise.all([
      initializeTable(),
      window.batchGeoGoogleMapsManager.doMap(),
      window.BatchGeoCluster(),
      initializeHeatmapComponent(),
    ]);

    if (BatchGeoStore.getState().App.mapMode === "store_locator") {
      window.batchGeoStoreLocator = new BatchGeoStoreLocator({
        map: window.batchGeoGoogleMapsManager.getMap(),
        containerElement: "#topBar",
        sizingElement: "#mapDiv",
        footerElement: "#legWrap",
        locationData: window.per.mapRS,
        phoneIndex: window.per.columnNames.indexOf(
          window.per.columnNames.find(
            (columnName) =>
              columnName.search(/(t(e|é)l(e|é)(f|ph)on(e|o)?)|phone/i) > -1,
          ),
        ),
      });

      BatchGeoStore.dispatch({
        type: "STORE_LOCATOR_LOCATIONS_UPDATE",
        locationData: window.per.mapRS,
      });

      //init lazyload, and lazy load images with class `lazy-thumbnail`
      //in order to lazy load an image, you need to replace the src attribute with data-src
      new window.LazyLoad({
        elements_selector: ".lazy-thumbnail",
      });
    }
  };

  var zoomToClosestMarkerUsingNativeGPS = function () {
    var userLocation = BatchGeoStore.getState().UserLocation;

    // Bail out if a user location isn't set
    if (!userLocation) {
      return;
    }

    window.geocodingEnabled = true;
    if (Math.abs(userLocation.latitude) > 0 && window.per.mapRS) {
      var shortest = 9999999,
        dist,
        row = 0;

      for (var i = 0; i < window.per.mapRS.length; i++) {
        dist = BatchGeo.distance(
          parseFloat(window.per.mapRS[i].lt),
          parseFloat(window.per.mapRS[i].ln),
          userLocation.latitude,
          userLocation.longitude,
        ).toFixed(2);
        if (parseFloat(dist) < parseFloat(shortest)) {
          row = i;
          shortest = dist;
        }
      }

      var buffer = new google.maps.Circle({
        center: new google.maps.LatLng(
          userLocation.latitude,
          userLocation.longitude,
        ),
        radius: 150,
      });

      var dbounds = buffer.getBounds();
      dbounds.extend(
        new google.maps.LatLng(
          window.per.mapRS[row].lt,
          window.per.mapRS[row].ln,
        ),
      );

      if (
        BatchGeoDevices.is("mobile") &&
        window.batchGeoGoogleMapsMarker.getMarkersObjArray() &&
        window.batchGeoGoogleMapsMarker.getMarkersObjArray()[row]
      ) {
        window.batchGeoGoogleMapsManager.getMap().fitBounds(dbounds);
      }

      window.openLocator = 0;
    } else {
      window.batchGeoGoogleMapsMarker.zoomToMarkers();
    }
  };

  var zoomToClosestByGPS = function () {
    if (!BatchGeo.modulesInitialized) {
      //We still don't have modules ready, initialize and come back
      return initializeModules(zoomToClosestByGPS);
    }

    doMap();

    var userLocation = BatchGeoStore.getState().UserLocation;

    // If we have a native user location saved, use it to zoom
    if (userLocation.latitude && userLocation.longitude) {
      // this will most likely never run the first time, check the batchgeo-user-location.js
      // file which will run this function one time on its first user location update
      zoomToClosestMarkerUsingNativeGPS();
    } else {
      window.geocodingEnabled = true;
      window.openLocator = 0;
      window.batchGeoGoogleMapsMarker.zoomToMarkers();
    }
  };

  // This allows the Others Group Marker to remain placed at the top right of the
  // group list, on resize, pagination, and load.
  window.reorderGroups = function () {
    var num = -1;
    let quantity = $(".groupList").children().length;

    $(".groupList").find("#targetItem").width("auto");

    $(".groupList > li").each(function (i, e) {
      $(".groupList")
        .find("#targetItem")
        .insertAfter(".groupList > li:eq(" + num + ")");
      if (
        $(e).offset().top ==
        $(".groupList")
          .children(quantity == 10 ? "" : "li:nth-child(2)")
          ?.first()
          ?.offset()?.top
      ) {
        num++;
      }
    });

    if (num <= 0) {
      $(".groupList")
        .find("#targetItem")
        .insertBefore(".groupList > li:eq(" + num + ")");
      $(".groupList").find("#targetItem").width("100%");
    } else {
      $(".groupList")
        .find("#targetItem")
        .insertAfter(".groupList > li:eq(" + num + ")");
      $(".groupList").find("#targetItem").width("auto");
    }
  };

  // runs on map detail pages (/map/..) to init page
  var bgInit = function (waitYet) {
    if (window.per && window.per.blank) {
      BatchGeo.timer("bgInit: blank data detected");
      BatchGeo.customAlert(
        "Map data appears to be missing,<br />rebuild from edit screen using source data.",
      );
      window.per = {
        columnNames: [],
        mapRS: [],
        dataRS: [],
      };
      return;
    } else if (!window.per || !window.per.mapRS) {
      // no data yet, go to sleep and try again in 50 milliseconds
      if (window.initTimer) clearTimeout(window.initTimer);
      if (typeof waitYet === "undefined")
        BatchGeo.timer("bgInit waiting for data...");
      window.initTimer = setTimeout(function () {
        bgInit(true);
      }, 50);
      return false;
    }

    var dataArray = window.per.dataRS;
    //filter empty rows
    for (let i = dataArray.length - 1; i >= 0; i--) {
      if (
        dataArray[i] &&
        dataArray[i].some((item) => {
          return item !== null && item !== undefined && item.trim() !== "";
        })
      ) {
        continue;
      }
      dataArray.splice(i, 1);
    }
    //filter empty columns
    for (let i = window.per.columnNames.length - 1; i >= 0; i--) {
      const columnHeader = window.per.columnNames[i];
      const header =
        columnHeader !== null &&
        columnHeader !== undefined &&
        columnHeader.trim() !== "";
      if (
        dataArray.some((row) => {
          var item = row[i];
          return (
            header ||
            (item !== null && item !== undefined && item.trim() !== "")
          );
        })
      ) {
        continue;
      }
      dataArray.map((row) => {
        if (!row || row.length <= i) return row;

        return row.splice(i, 1);
      });
    }
    window.per.dataRS = dataArray;

    BatchGeoStore.dispatch({
      type: "CLUSTER_SET_ENABLED",
      clusterSetting:
        typeof window.per.clustering_cb_status !== "undefined" &&
        window.per.clustering_cb_status,
    });

    if (!BatchGeo.modulesInitialized) {
      //We still don't have modules ready, initialize and come back
      return initializeModules(bgInit);
    }

    BatchGeo.timer("start bgInit");

    window.batchGeoOmnibox = new BatchGeoOmnibox({
      container: $("#searchForm"),
      omniboxInput: $("#addressBox"),
    });

    // Fire an event so modules can listen for the data load
    $(window).trigger("batchgeo.dataload");

    // TODO(tom) we should get locale/language out of global vars and into a config system
    // eslint-disable-next-line no-global-assign
    locale = window.per.locale =
      typeof window.per.locale !== "undefined" ? window.per.locale : "us"; // default to us
    // eslint-disable-next-line no-global-assign
    language =
      typeof language !== "undefined"
        ? language
        : window.navigator.userLanguage || window.navigator.language;
    // eslint-disable-next-line no-global-assign
    language = BatchGeo.leftSubStr(language, 2);
    window.per.hideaddr_cb =
      window.per.hideaddr_cb !== undefined ? window.per.hideaddr_cb : false; // default to false
    window.per.linkopwin_cb =
      window.per.linkopwin_cb !== undefined ? window.per.linkopwin_cb : true; // default to true
    window.per.dist_cb_status =
      window.per.dist_cb_status !== undefined
        ? window.per.dist_cb_status
        : false; // default to false
    window.per.dist_sel =
      window.per.dist_sel !== undefined ? window.per.dist_sel : 0; // default to 0
    window.per.group_data = window.per.group_data ? window.per.group_data : [];

    if (!BatchGeoStore.getState().App.isEdit) {
      window.onbeforeunload = function () {
        BatchGeo.setMapViewCache();
      };
    }

    if (window.location.hash && window.location.hash.replace("#", "")) {
      window.openRow = parseFloat(window.location.hash.replace("#", ""));
      //if named anchor in url, subtract 1 to match the index of dataRS array
      window.openRow = window.openRow - 1;
    }

    if (
      !BatchGeo.iframeDetect() &&
      !window.printMode &&
      BatchGeoDevices.is("mobile") &&
      !BatchGeo.getQueryVariable("q").length
    ) {
      window.openLocator = 1;
      zoomToClosestByGPS(); // load map and zoom in to GPS
    } else if (window.per && window.per.mapRS && window.per.mapRS.length) {
      // in iframe or no geolocation stuff, so just run doMap()
      doMap();
    } else
      BatchGeo.customAlert(
        "Data load error, try reloading the page or rebuilding map.",
      );

    bgSize();
  };

  BatchGeoMap.prototype.mapReset = function (e) {
    $("#addressBox, .batchgeo-omnibox input").val("").blur().trigger("change");

    window.batchGeoGoogleMapsMarker.MarkerLegend.clearFilters(); // this will run drawMarkers()
    var map = window.batchGeoGoogleMapsManager.getMap();

    map.setMapTypeId(
      window.per.style.indexOf("simple") === -1
        ? "simpleMap"
        : google.maps.MapTypeId.ROADMAP,
    );

    //deselect all rows from the table when resetting the map.
    if (BatchGeoStore.getState().App.advanced) {
      window.batchGeoTableMap.batchGeoTable.RowSelect.deselectAll();
    }

    BatchGeoStore.dispatch({
      type: "MAPSMARKERS_MANAGER_RESET",
    });

    BatchGeo.setMapViewCache();
    BatchGeoStore.dispatch({ type: "MARKER_MEASURE_DISABLE" });
    // window.batchGeoBaseToolbar.activeButtonManager.removeActiveStates();
    BatchGeoStore.dispatch({
      type: "HEATMAP_SET_ENABLED",
      enabled: window.per.heatmap_default,
    });

    BatchGeoStore.dispatch({
      type: "DRAWING_MANAGER_SET_MODE",
      mode: "hand",
    });

    window.per.custom_extent
      ? map.fitBounds(window.per.custom_extent)
      : window.batchGeoGoogleMapsMarker.zoomToMarkers();

    if (e) e.preventDefault();

    //if there's any search results that clear them out
    BatchGeoStore.dispatch({
      type: "STORE_UPDATE_SEARCH_LOCATION",
      searchLocation: null,
    });

    if (
      BatchGeoStore.getState().BatchGeoOptimalRouteToolbar.polylineData.length >
      0
    ) {
      window.ClearDistanceCalculations();
    }
  };

  BatchGeoMap.prototype.bgInit = bgInit;
  BatchGeoMap.prototype.bgSize = bgSize;
  BatchGeoMap.prototype.doMap = doMap;
  BatchGeoMap.prototype.initializeModules = initializeModules;
  BatchGeoMap.prototype.disableAdvancedMode = disableAdvancedMode;
  BatchGeoMap.prototype.zoomToClosestMarkerUsingNativeGPS =
    zoomToClosestMarkerUsingNativeGPS;

  window.BatchGeoMap = BatchGeoMap;
})(window);
